import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { isAdmin } from '../utils/permissions';
import useBrainAccess from '../hooks/useBrainAccess';

/**
 * Garde des routes /brain. Deux conditions, toutes deux necessaires :
 *   - role admin (via le helper, jamais userProfile.role en ligne)
 *   - l'organisation a le plan Brain
 *
 * Ferme par defaut : tant que la reponse n'est pas connue, on attend ; si
 * elle est negative, on renvoie a la liste des projets plutot que d'afficher
 * une page vide.
 */
const RequireBrain = ({ children }) => {
  const { userProfile } = useAuth();
  const { canUseBrain, loading } = useBrainAccess();

  if (loading) {
    // Meme etat d'attente que RequireAuth, pour que la transition ne saute pas.
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="inline-block w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin(userProfile) || !canUseBrain) {
    return <Navigate to="/project-detail" replace />;
  }

  return children;
};

export default RequireBrain;
